import { render, staticRenderFns } from "./TheBackButton.vue?vue&type=template&id=2f034ec2"
import script from "./TheBackButton.vue?vue&type=script&lang=js"
export * from "./TheBackButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports